export var FAVOURITES_SUMMARY_FETCHED_EVENT = 'FAVOURITES_SUMMARY_FETCHED';
export var FAVOURITE_ADDED_EVENT = 'FAVOURITE_ADDED';
export var FAVOURITE_REMOVED_EVENT = 'FAVOURITE_REMOVED';